module.exports = __webpack_public_path__ + "static/img/WhatsApp Image 2024-11-02 at 16.50.10.9f8c64e6.jpg";